import { render, staticRenderFns } from "./mainpage.vue?vue&type=template&id=b2495772&scoped=true&"
import script from "./mainpage.js?vue&type=script&lang=js&"
export * from "./mainpage.js?vue&type=script&lang=js&"
import style0 from "./mainpage.vue?vue&type=style&index=0&id=b2495772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2495772",
  null
  
)

export default component.exports